var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinSolidLargeActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6706 8.29146L13.7644 0.331658C13.3252 -0.110553 12.6663 -0.110553 12.2271 0.331658C11.7879 0.773869 11.7879 1.43719 12.2271 1.8794L12.4467 2.1005L6.07786 6.63317L2.56401 7.07538C1.46593 7.29648 0.477664 8.07035 0.148241 9.06533C-0.181183 10.0603 0.0384328 11.2764 0.807088 11.9397L4.65036 15.809L1.90517 18.5729C1.46593 19.0151 1.46593 19.6784 1.90517 20.1206C2.12478 20.3417 2.45421 20.4523 2.67382 20.4523C2.89344 20.4523 3.22286 20.3417 3.44248 20.1206L6.18767 17.3568L10.0309 21.2261C10.58 21.7789 11.2388 22 12.0075 22C12.3369 22 12.6663 22 12.8859 21.8894C13.984 21.5578 14.7527 20.5628 14.8625 19.4573L15.4115 15.9196L19.8038 9.61809L20.1333 9.94975C20.3529 10.1709 20.6823 10.2814 20.9019 10.2814C21.1215 10.2814 21.451 10.1709 21.6706 9.94975C22.1098 9.50754 22.1098 8.73367 21.6706 8.29146Z",
    fill: "#E4B900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSolidLargeActive);
export default __webpack_public_path__ + "static/media/pin_solid_large_active.0f5d98c496ea0f5d5f83ae83594a27b5.svg";
export { ForwardRef as ReactComponent };